import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AddCoverImageIcon from '@wix/da-ds/pkg/Icons/24x24/AddCoverImage';

import s from './CoverPlaceholder.scss';

interface Props {
  width?: number;
  height?: number;
}

const CoverPlaceholder: FC<Props> = ({ width, height }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']} style={{ width, height }}>
      <AddCoverImageIcon disableDefaultColors />
      <div className={s['placeholder-text']}>{t('studio.table.thumb.coverPlaceholder')}</div>
    </div>
  );
};
CoverPlaceholder.displayName = 'CoverPlaceholder';

export default CoverPlaceholder;
